// extracted by mini-css-extract-plugin
export default {"logo-icon":"B0RNK","logoIcon":"B0RNK","logo":"NpV02","hide":"mUJ65"};